module.exports = "<agm-map [latitude]=\"coords.lat\" [longitude]=\"coords.lng\" *ngIf=\"coords.lat\" [zoom]=\"10\">\n  <agm-marker [latitude]=\"coords.lat\" [longitude]=\"coords.lng\"></agm-marker>\n</agm-map>";


//////////////////
// WEBPACK FOOTER
// ./app/components/event-map/event-map.component.html
// module id = 1007
// module chunks = 0